import { useSearchParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const PrivacyPolicyPage = () => {
  const [searchParams] = useSearchParams();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">プライバシーポリシー</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              IVA株式会社（以下「当社」といいます）は、個人情報保護の重要性について認識し、個人情報の保護に関する法律(以下「個人情報保護法」といいます)を遵守すると共に、以下のプライバシーポリシー(以下「本プライバシーポリシー」といいます)に従い、適切な取扱い及び保護に努めます。なお、本プライバシーポリシーにおいて別段の定めがない限り、本プライバシーポリシーにおける用語の定義は、個人情報保護法の定めに従います。
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第１条（個人情報）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                「個人情報」とは、個人情報の保護に関する法律（平成15年法律第57号、以下「個人情報保護法」といいます）２条１項に定める個人情報を指すものとします。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第２条（適用範囲）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                本プライバシーポリシーにおいては、「DONDON」のサービス名で提供する全てのウェブサイト、ソフトウェア、アプリケーション、プロダクト、ドキュメントその他一切の製品及びサービスに適用されます。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第３条（個人情報の収集方法)</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                当社は、個人情報を取得する場合には、適性かつ公正な方法にてこれを行うものとします。 また、当社は、予め同意を得た場合又は法令で認められる場合を除き、要配慮個人情報を取得しません。ユーザーがオンラインストアその他の当社サービスのアカウントを第三者サービス（Google、Facebook、LINE等）のアカウントと連携及び接続する場合、当社は、連携した第三者サービスのID、氏名又は名称、メールアドレスを取得いたします。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第４条（個人情報を収集・利用する目的）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                当社が個人情報を収集・利用する目的は、以下のとおりです。<br/>
                情報の種類<br/>
                顧客情報、ユーザー情報（閲覧履歴、購買履歴等の個人関連情報を含みます。）<br/>
                利用目的<br/>
                １　「DONDON」その他の当社サービス（以下「当社サービス」といいます）の提供・運営・改善のため<br/>
                ２　商品の注文の受付及び発送、ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）<br/>
                ３　ユーザーが利用中のサービスの新機能、更新情報、キャンペーン等及び当社が提供する他のサービスの案内のメールを送付するため<br/>
                ４　メンテナンス、重要なお知らせなど必要に応じた連絡のため<br/>
                ５　利用規約に違反したユーザー又は不正若しくは不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため<br/>
                ６　ユーザーに自身の登録情報の閲覧や変更、削除、利用状況の閲覧を行っていただくため<br/>
                ７　有料サービスにおいて、ユーザーに利用料金を請求するため<br/>
                ８　統計データ等、個人を特定できないデータを作成するため<br/>
                ９　広告配信事業者を利用した行動ターゲティング広告の配信<br/>
                10　取得した閲覧履歴や購買履歴等の情報を分析して、趣味・趣向に応じた商品・当社サービスを広告するため<br/>
                11　当社の新しいサービスを研究・開発するため<br/>
                12　当社が、ユーザーに代わって、公認ショップ（当社所定の基準に従い、当社が公認した出品者を意味します。以下同じ。）に対して、ユーザーの情報を提供するため<br/>
                13　当社と守秘義務契約を結んだ第三者と「情報の預託」に基づき個人情報を利用するため<br/>
                14　クレジットカードの不正利用検知・防止のため<br/>
                15　上記の利用目的に付随する目的
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第５条（利用目的の変更）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                当社は、個人情報の利用目的を関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合には個人情報の主体である個人（以下「本人」といいます）に通知し又は公表します。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第６条（適切な安全管理措置の実施）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                当社は、保有する個人情報に関し、不正アクセス、改ざん、漏洩、滅失または毀損等を防止するため、個人情報管理責任者の設置、内部規律の整備、入退出管理、持ち込み機器の制限、情報へのアクセス制限、盗難防止措置、不正アクセス防止措置等必要かつ適切な安全管理措置を講じます。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第７条（個人情報の第三者提供）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                １　当社は、個人情報保護法その他の法令により許容される場合を除き、本人の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。但し、次の場合はこの限りではありません。<br/>
                　①　法令に基づく場合<br/>
                　②　人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき<br/>
                　③　公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき<br/>
                　④　国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき<br/>
                ２　前項に拘わらず、ユーザーは、当社サービスを利用して公認ショップから商品を購入するに際して、当社に対して、当社がユーザーに代わって、ユーザー情報を公認ショップに提供することを委託するものとします。<br/>
                ３　前項に拘わらず、ユーザーは、当社がユーザーから収集した以下の個人情報等を、カード発行会社が行う不正利用検知・防止のために、ユーザーが利用しているカード発行会社へ提供することを委託するものとします。<br/>
                カード名義、電話番号、IPアドレス<br/>
                ユーザーが利用しているカード発行会社が外国にある場合、これらの情報は当該発行会社が所属する国に移転される場合があります。当社では、ユーザーから収集した個人情報等からは、ユーザーの利用するカード発行会社及び当該会社が所在する国を特定することができないため、ユーザーに対して、以下の個人情報保護措置に関する情報を把握して、ご提供することはできません。<br/>
                ・提供先が所在する外国の名称　<br/>
                ・当該国の個人情報保護制度に関する情報<br/>
                ・発行会社の個人情報保護の措置<br/>
                なお、個人情報保護委員会のホームページ（<a href="https://www.ppc.go.jp/" className="text-black underline">https://www.ppc.go.jp/</a>）では、各国における個人情報保護制度に関する情報について掲載されていますので、ご確認ください。<br/>
                なお、ユーザーが未成年の場合、親権者または後見人の承諾を得た上で、当社サービスを利用するものとします。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第８条（個人情報の取り扱いの委託）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                当社は、利用目的の達成に必要な範囲内において個人情報の取り扱いを業務委託先に委託することがございます。その際、業務委託先としての適格性を十分審査するとともに、契約にあたって守秘義務に関する事項等を規定することにより、個人情報が必要かつ適切に管理されるように監督を実施します。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第９条（個人情報及び利用目的の開示）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                当社は、本人から、個人情報保護法の定めに基づき個人情報及び個人情報の利用目的の開示を求められたときは、本人ご自身からのご請求であることを確認の上で、本人に対し、遅滞なく開示を行います(当該個人情報が存在しないときにはその旨を通知いたします)。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第10条（個人情報の訂正及び削除）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                １　ユーザーは、当社の保有する自己の個人情報が誤った情報である場合には、当社が定める手続きにより、当社に対して個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。<br/>
                ２　当社は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。<br/>
                ３　当社は、前項の規定に基づき訂正等を行った場合、又は訂正等を行わない旨の決定をしたときは遅滞なく、これをユーザーに通知します。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第11条（個人情報の利用停止等）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                １　当社は、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、違法又は不当な行為を助長し、若しくは助長する恐れがある方法により個人情報が利用されているという理由、あるいは不正の手段により取得されたものであるという理由により、その利用の停止又は消去（以下、「利用停止等」といいます。）を求められた場合には、遅滞なく必要な調査を行います。<br/>
                ２　前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行います。<br/>
                ３　当社は、前項の規定に基づき利用停止等を行った場合、又は利用停止等を行わない旨の決定をしたときは、遅滞なく、これをユーザーに通知します。<br/>
                ４　前２項にかかわらず、利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって、ユーザーの権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じるものとします。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第12条（Cookieその他の技術の利用）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                当社は、クッキーを使用しております。ブラウザーの設定により、クッキーの使用の制限等を行うことができますが、クッキーの使用を制限した場合、当社のサービスやウェブサイトでご利用いただくことができる機能が制限される可能性がある点ご留意下さい。また、当社は、ウェブサイトの利用状況を把握するためにGoogle Analyticsを利用しております。データの収集、処理方法等のGoogle Analyticsの詳細については、下記のURLをご参照ください。<br/>
                <a href="https://marketingplatform.google.com/about/analytics/terms/jp/" className="text-black underline">https://marketingplatform.google.com/about/analytics/terms/jp/</a><br/>
                <a href="https://policies.google.com/privacy" className="text-black underline">https://policies.google.com/privacy</a><br/>
                <a href="https://policies.google.com/technologies/partner-sites" className="text-black underline">https://policies.google.com/technologies/partner-sites</a>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第13条（プライバシーポリシーの変更）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                １　本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。<br/>
                ２　当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第14条（お問い合わせ）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                個人情報の開示・訂正及び利用・提供の中止の申出、本ポリシーに関してご不明点がある場合、下記までご連絡をお願いいたします。<br/>
                ・運営会社：IVA株式会社<br/>
                ・店舗名：DONDON<br/>
                ・個人情報保護管理責任者：相原嘉夫<br/>
                ・お問い合わせ：<a href="mailto:info@dondoncard.com" className="text-black underline">info@dondoncard.com</a>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">第15条（個人情報取扱事業者の名称、住所及び代表者の氏名）</div>
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                東京都渋谷区渋谷2-22-5　シブロジ３F<br/>
                IVA株式会社<br/>
                代表取締役 相原嘉夫
              </div>
            </div>
            
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              2025年8月4日 制定
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default PrivacyPolicyPage;